import type {
	InviteStripeTeacherResponse,
	StripeSchoolSeatsResponse,
	StripeSchoolTeachersResponse,
} from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

// SUB-95 Phase 1: the Stripe-billed school-admin panel. Kept deliberately
// separate from the legacy `GET_SCHOOL_TEACHERS` / `GET_SCHOOL_SEATS` action
// types so the two panels never share state.

export enum GET_STRIPE_SCHOOL_TEACHERS {
	START = 'GET_STRIPE_SCHOOL_TEACHERS_START',
	SUCCESS = 'GET_STRIPE_SCHOOL_TEACHERS_SUCCESS',
	ERROR = 'GET_STRIPE_SCHOOL_TEACHERS_ERROR',
}

export type GetStripeSchoolTeachersAction = AsyncAction<
	typeof GET_STRIPE_SCHOOL_TEACHERS.START,
	typeof GET_STRIPE_SCHOOL_TEACHERS.SUCCESS,
	typeof GET_STRIPE_SCHOOL_TEACHERS.ERROR,
	StripeSchoolTeachersResponse
>;

export enum GET_STRIPE_SCHOOL_SEATS {
	START = 'GET_STRIPE_SCHOOL_SEATS_START',
	SUCCESS = 'GET_STRIPE_SCHOOL_SEATS_SUCCESS',
	ERROR = 'GET_STRIPE_SCHOOL_SEATS_ERROR',
}

export type GetStripeSchoolSeatsAction = AsyncAction<
	typeof GET_STRIPE_SCHOOL_SEATS.START,
	typeof GET_STRIPE_SCHOOL_SEATS.SUCCESS,
	typeof GET_STRIPE_SCHOOL_SEATS.ERROR,
	StripeSchoolSeatsResponse
>;

// SUB-96: the invite mutation. It keeps no reducer state of its own — the
// modal branches on the returned action and the page refetches the two reads.
export enum INVITE_STRIPE_SCHOOL_TEACHER {
	START = 'INVITE_STRIPE_SCHOOL_TEACHER_START',
	SUCCESS = 'INVITE_STRIPE_SCHOOL_TEACHER_SUCCESS',
	ERROR = 'INVITE_STRIPE_SCHOOL_TEACHER_ERROR',
}

export type InviteStripeSchoolTeacherAction = AsyncAction<
	typeof INVITE_STRIPE_SCHOOL_TEACHER.START,
	typeof INVITE_STRIPE_SCHOOL_TEACHER.SUCCESS,
	typeof INVITE_STRIPE_SCHOOL_TEACHER.ERROR,
	InviteStripeTeacherResponse
>;

export type StripeSchoolTeachersActionTypes =
	| GetStripeSchoolTeachersAction
	| GetStripeSchoolSeatsAction
	| InviteStripeSchoolTeacherAction;
